import * as R from "remeda";
import * as ShortMonth from "./short-month.js";
import { londonNow } from "./time.js";
import * as TwoDigitYear from "./two-digit-year.js";
export const defaultMonthsRangeSettings = 72;
const date = londonNow();
const quarterMap = ["Q1", "Q2", "Q3", "Q4"];
const halfMap = ["H1", "H2"];
const currentMonthNum = date.getMonth();
const currentYearNum = date.getFullYear() % 100;
function generateSeasonLookups({ currentMonthNum, currentYearNum, periods, }) {
    const lookups = {};
    let isSum = currentMonthNum >= 3 && currentMonthNum < 9;
    let year = currentMonthNum < 3 ? currentYearNum - 1 : currentYearNum;
    for (let i = 0; i < periods; i++) {
        lookups[`REL-S${i}`] = `${isSum ? "Sum" : "Win"} ${TwoDigitYear.fromNumber(year)}`;
        if (!isSum)
            year += 1;
        isSum = !isSum;
    }
    return lookups;
}
function generateAdhocLookups({ periods }) {
    const lookups = {};
    for (let i = 0; i < periods; i++) {
        lookups[`REL-A${i}`] = `Adhoc${i + 1}`;
    }
    return lookups;
}
export function generateLookups({ periods, prefix, getIndex, getLabel, getYear, affix, }) {
    const obj = {};
    for (let i = 0; i < periods; i++) {
        const value = `${getLabel(getIndex(i))}${affix}${TwoDigitYear.fromNumber(getYear(i))}`;
        obj[`${prefix}${i}`] = value;
    }
    return obj;
}
export const monthLookups = generateLookups({
    periods: defaultMonthsRangeSettings,
    prefix: "REL-M",
    getIndex: (i) => (currentMonthNum + i) % 12,
    getLabel: (index) => ShortMonth.shortMonths[index],
    getYear: (i) => currentYearNum + Math.floor((currentMonthNum + i) / 12),
    affix: "",
});
export const quarterLookups = generateLookups({
    // one beyond the full-window count: the last settings option can be a quarter only partially inside the month range
    periods: defaultMonthsRangeSettings / 3 + 1,
    prefix: "REL-Q",
    getIndex: (i) => Math.floor((currentMonthNum + i * 3) / 3) % 4,
    getLabel: (index) => quarterMap[index],
    getYear: (i) => currentYearNum + Math.floor((currentMonthNum + i * 3) / 12),
    affix: " ",
});
export const halfLookups = generateLookups({
    // one beyond the full-window count: the last settings option can be a half only partially inside the month range
    periods: defaultMonthsRangeSettings / 6 + 1,
    prefix: "REL-H",
    getIndex: (i) => (Math.floor(currentMonthNum / 6) + i) % 2,
    getLabel: (index) => halfMap[index],
    getYear: (i) => currentYearNum + Math.floor((Math.floor(currentMonthNum / 6) + i) / 2),
    affix: " ",
});
export const seasonLookups = generateSeasonLookups({
    currentMonthNum,
    currentYearNum,
    // one beyond the full-window count: the last settings option can be a season only partially inside the month range
    periods: defaultMonthsRangeSettings / 6 + 1,
});
export const yearLookups = generateLookups({
    // one beyond the full-window count: the last settings option can be a year only partially inside the month range
    periods: defaultMonthsRangeSettings / 12 + 1,
    prefix: "REL-C",
    getIndex: (i) => i,
    getLabel: () => "Cal",
    getYear: (i) => currentYearNum + i,
    affix: " ",
});
export const adhocLookups = generateAdhocLookups({ periods: 20 });
// TS infers this as {}, so insist it's something slightly more useful
export const relativeRowToRowId = {
    ...monthLookups,
    ...quarterLookups,
    ...halfLookups,
    ...seasonLookups,
    ...yearLookups,
    ...adhocLookups,
};
export const rowIdToRelativeRow = R.invert(relativeRowToRowId);
export const relativeRowToRowTypeLookup = {
    ...R.mapValues(monthLookups, () => "mth"),
    ...R.mapValues(quarterLookups, () => "qtr"),
    ...R.mapValues(halfLookups, () => "hlv"),
    ...R.mapValues(seasonLookups, () => "season"),
    ...R.mapValues(yearLookups, () => "cal"),
    ...R.mapValues(adhocLookups, () => "adhoc"),
};
//# sourceMappingURL=rows.js.map